import React, {useContext} from 'react';
import PropTypes from 'prop-types';
import {ScreenDesignerContextNew} from "../../../../../../../../ContextComponents/ScreenDesignerContextNew";
import {useDrop} from "react-dnd";
import {AcceptTypes} from "../../../ToolBar/ToolBarUtils/ItemTypes";
import RenderComponents from "../RenderByType/RenderComponents";

const SwiperItem = props => {
    const {component, component: {children, styles}, path, index: parentIndex} = props;
    const sourceStyles = styles ? styles[0] : {};
    const {
        onDropComponent, onMoveComponent, onSelectComponent
    } = useContext(ScreenDesignerContextNew);
    const hasChildren = children && children.length;
    const [{isOverCurrent}, drop] = useDrop({
        accept: AcceptTypes.column,
        collect: monitor => ({
            isOverCurrent: monitor.isOver({shallow: true}),
        }),
        drop: (item, monitor) => {
            const didDrop = monitor.didDrop();
            let newItem = {...item};
            if (didDrop) {
                return;
            }
            if (item.children && item.type === 'panel') {
                return
            }
            if (item.dragType === 'multiple') {
                return

            }
            if (item.dragType === 'move') {

                //insert panel inside container
                if (item.component.type === 'panel') {
                    return
                }

                onMoveComponent(item.component, item.from, `${path}.children`, children.length, item.index, parentIndex);
                return
            }

            onDropComponent(newItem, children.length, `${path}.children`)
        }
    });

    return (
        <div ref={drop}
             onClick={(e) => {
                 onSelectComponent(component, path)
                 e.stopPropagation();
             }}
             style={{
                 ...sourceStyles,
                 border: '1px dashed red'
             }}
        >
            {hasChildren ? (
                children.map((item, index) => {
                    return (
                        <RenderComponents
                            key={index}
                            type={item.type}
                            item={item}
                            index={index}
                            path={`${path}.children.${index}`}
                            parentPath={path}
                        />
                    )
                })
            ) : (
                isOverCurrent && (
                    <div style={{background: '#009688', height: 10, alignSelf: 'center', width: '100%'}}>

                    </div>
                )
            )}
        </div>
    );
};

SwiperItem.propTypes = {
    component: PropTypes.object,
    path: PropTypes.string,
    index: PropTypes.number
};

export default SwiperItem;